import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import { INSTANT_GAME_TYPE, DRAW_GAME_TYPE } from 'app/config/gametype';
import { checkAccess } from 'app/actions/app.actions';
import { isChainHeadSelector, isSuperChainSelector } from 'selectors/index';
import * as api from 'dashboard/resources/big-winners.api';
import template from './big-winners-widget.html';

const BIG_WINNERS_HISTORY = 'bigWinners.history';

const mapStateToThis = ({ session, config, dictionary }) => {
  const { locale, retailer } = session;
  const isSuperChain = isSuperChainSelector({ session });
  const isChainHead = isChainHeadSelector({ session });
  const { bigWinnersSellPeriodDays } = config;
  const terms = dictionary.terms[locale];

  return {
    retailer,
    isSuperChain,
    isChainHead,
    bigWinnersSellPeriodDays,
    terms,
  };
};

const mapDispatchToThis = {
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', '$state')
class BigWinnersController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.INSTANT_GAME_TYPE = INSTANT_GAME_TYPE;
    this.DRAW_GAME_TYPE = DRAW_GAME_TYPE;
    this.isHistoryLinkVisible = (!this.isSuperChain || this.isChainHead) && this.checkAccess(BIG_WINNERS_HISTORY);
    const retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.loadDataAsync(() => api.fetchBigWinners(retailerId, this.gameType));
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class BigWinnersComponent {
  constructor() {
    this.bindings = {
      isEditMode: '<',
      isDisabledShare: '<',
      isRemovable: '<',
      removeWidget: '&?',
      gameType: '@',
    };
    this.template = template;
    this.controller = BigWinnersController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/big-winners/big-winners-widget-component.js